module.exports = __webpack_public_path__ + "static/media/seatplan.a07d930a.png";